module.exports = __webpack_public_path__ + "img/ic_send_sel.9d30517b.svg";